//IM接口模块

//引入接口文档
import req from '@/utils/req.js'


//获取或注册腾讯IM账号
export function api_postimacc(params) {
    return req.post("/admin/user-im-account/getTimAccount", params);
}

//获取userSig
export function api_getimuserSig(params) {
    return req.get("/admin/user-im-account/getTencentUserSig", params);
}


//获取房间号
export function api_getimroom(params) {
    return req.get("/admin/chat-room/getGroupIdByWholeId", params);
}

//医护上门发送消息
export function api_sendDocter(params) {
    return req.post("/admin/nursing-service-im/sendImMessage",params);
}

// 前端发送文字消息
export function api_sendTimText(params) {
    return req.post("/admin/tim/sendTimText", params);
}
// 专项会话

//根据全病程id 获取问诊列表
export function api_getInquiryList(params) {
    return req.get("/admin/inquiry-info/getInquiryListByWholeCourseId", params);
}

//新增列表根据全病程id获取成员列表
export function api_getMembersByWholeId(params) {
    return req.get("/admin/chat-room/getMembersByWholeId", params);
}

//创建全病程接口
export function api_createWholeInquiry(params) {
    return req.post("/admin/inquiry-info/createWholeInquiry", params);
}


//获取问诊信息  、、房间号
export function api_getintoInquiryRoom(params) {
    return req.post("/admin/inquiry-info/intoInquiryRoom", params);
}


//获取问诊类型，时间
export function api_getgetServiceByType(params) {
    return req.get("/admin/inquiry-service/getServiceByType", params);
}



//获取个案工作台每个模块需要处理事件的数字
export function api_get_case_message(params) {
    return req.get("/admin/case-mgr-message", params);
}
//发送随访记录申请
export function sendFollowUpMessage(params) {
    return req.post("/admin/inquiry-info/sendFollowUpMessage", params);
}
//保存随访问卷
export function saveFollowUpRecords(params) {
    return req.post("/admin/follow-up-records/saveFollowUpRecords", params);
}
//反馈处理更新
export function feedback(params) {
    return req.put("/admin/feedback", params);
}



//培训教程目录列表分页查询
export function api_get_train_chapter(params) {
    return req.get("/admin/train-chapter/page", params);
}
// 疗管发送在线教程列表
export function  getChapter(params) {
    return req.post("/admin/train-chapter/pageQuery", params);
}

//培训教程推送 单条
export function api_get_train_chapter_push(params) {
    return req.post("/admin/train-chapter/push", params);
}
//在线教程推送 多条
export function chapter_push_batch(params) {
    return req.post("/admin/train-chapter/push/batch", params);
}
//宣教列表分页查询
export function api_get_mission(params) {
    return req.post("/admin/mission/page", params);
}
// 疗管健康宣教
export function  getMissionData(params) {
    return req.post("/admin/mission/pageQuery", params);
}

// 宣传问卷推送
export function api_admin_push_mission(params) {
    return req.post("/admin/mission/push/mission", params);
}
// 疗管-健康宣教多条推送
export function mission_push_batch(params) {
    return req.post("/admin/mission/push/batch", params);
}


//问卷列表分页查询
export function api_get_survey_oss(params) {
    return req.get("/dsicm-survey/oss/surveys", params);
}

//问卷推送
export function api_post_push_survey(params) {
    return req.post("/admin/survey/push/survey", params);
}

//获取历史消息列表
export function api_post_getRecordByRoomCode(params) {
    return req.post("/admin/chat-record/getRecordByRoomCode", params);
}



//添加照片到对照录入
export function api_post_addTofoles(params) {
    return req.post("/admin/patient-files/addToFiles", params);
}

//获取当前账号为什么角色
export function api_get_user_role(params) {
    return req.get("/admin/user-role/admin", params);
}
//搜索聊天记录
export function api_get_messList(params) {
    return req.post("/admin/chat-record/getRecordByKeyWords", params);
}
//定位未读消息
export function locationSessionRecords(params) {
    return req.post("/admin/chat-record/locationSessionRecords", params);
}
//结束问诊发送卡片
export function sendDelayEnd(params) {
    return req.get("/admin/inquiry-info/sendDelayEnd", params);
}
//获取房间状态
export function intoInquiryRoom(params) {
    return req.post("/admin/inquiry-info/intoInquiryRoom", params);
}
//获取成员列表
export function getMembersByGroupCode(params) {
    return req.get("/admin/chat-room/getMembersByGroupCode", params);
}









/*************新版推送问卷，量表等接口********* */
// 问卷分页查询
export function getMissonList(params) {
    return req.post("/admin/exam-paper/pageList", params);
}
// 宣传问卷推送
export function api_admin_push_mission_new(params) {
    return req.post("/admin/mission/push/mission", params);
}

export function pushMissionIM(params) {
    return req.post("/admin/exam-paper/pushIm", params);
}

export function pushMissionIMNew(params) {
    return req.post("/admin/exam-paper/pushImSingle", params);
}

/***************************************** 新版已读未读获取序号 **************************************** */
export function getReadySequence(params) {
    return req.get("/admin/chat-record-ack/getPatientLastReadMsgSeq", params);
}
/***************************************** 新版已读未读获取序号 **************************************** */
export function getReadyDocSequence(params) {
    return req.get("/admin/chat-record-ack/getLastReadMsgSeqMapGroupByTimType", params);
}

// 处方医生列表
export function getPrescriberListByTeamId(params) {
    return req.get("/admin/doctor/getPrescriberListByTeamId", params);
}

/** 
 *图片/语音/视频/文件消息
 *先上传到/dsicm-contact-platform/feign/file/upload
 *参数path：对应为tim-image、tim-sound、tim-video、tim-file
**/
export function specialFileUpdate(params) {
    return req.post("/admin/tim/sendTimCustom", params);
}

/***************************************** 专项会话 **************************************** */
// 患者的方案详细查询
export function getPatientRights(params) {
  return req.get(`/admin/patient-scheme-rights/${params}`);
}

// 根据患者id获取问诊信息
export function getInquiryInfoByPatientId(params) {
  return req.get("/admin/inquiry-info/getInquiryInfoByPatientId", params);
}

// 创建问诊
export function createInquiry(params) {
  return req.post("/admin/inquiry-info/createInquiry", params);
}

// 获取问诊医生
export function getInquiryDoctors(params) {
  return req.get("/admin/doctor/getInquiryDoctors", params);
}

// 获取主诊医生
export function getAttendingDoctorByTeamId(params) {
  return req.get("/admin/doctor/getAttendingDoctorByTeamId", params);
}

// 获取问诊团队
export function getInquiryDoctorTeams(params) {
  return req.post("/admin/doctor-team/getInquiryDoctorTeams", params);
}

// 个案主动结束问诊
export function caseMgrCancelled(params) {
  return req.get("/admin/inquiry-info/caseMgrCancelled", params);
}

//订单主表详细查询
export function getOrderDetails(params) {
  return req.get(`/admin/order/${params}`)
}

// 通过platformId查询线下机构信息
export function getListByPlatformId(params) {
  return req.post(`/admin/hospital/getListByPlatformId?platformId=${params}`);
}

//问诊配置信息表详情RefId查询
export function detailByRefId(params) {
  return req.get("/admin/inquiry-config/detailByRefId", params);
}

// im文本消息撤回
export function chatRecordRecall(params) {
    return req.post(`/admin/chat-record/recall`, params);
}

// 病历夹推送
export function patientCaseHistoryPush(params) {
    return req.post(`/admin/patient-case-history/push`, params);
}
// 协同会话问诊订单 
export function listSynergyInfo(params) {
    return req.post("/biz/synergy-record/listSynergyInfo", params);
}
// 重新申请
export function synergyReset(params) {
    return req.post("/biz/synergy-record/reset", params);
} 
//取消协同订单 
export function synergyCancelled(params) {
  return req.get("/biz/synergy-record/caseMgrCancelled", params);
}
// 获取声网房间详情 
export function dsicmRtc(params) {
    return req.get(`/dsicm-rtc/feign/dsicm-rtc/${params.bizType}/${params.id}`, {});
}
//获取房间在线人数 
export function getOnlineCount(params) {
    return req.get(`/dsicm-rtc/feign/dsicm-rtc/getOnlineCount/${params.bizType}/${params.id}`, {});
}
// 声网创建token 
export function createToken(params) {
    return req.post("/dsicm-api/feign/synergy-record/create-user-token", params);
} 
//会诊详情 
export function synergyDetails(id) {
    return req.get(`/biz/synergy-record/${id}`, {});
}
